import { PayableInboxModel } from "@/Billing/Models/UI/PaybleInboxModel";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { BillingStore } from "../../BillingStore";

class PayableInboxHandler extends BaseOperationHandler {
    constructor() {
        super();

        this.RegisterOperation(LocalOperations.Billing.Payable_LoadPaybleInboxItems, this.loadPayableInbox);
    }

    private loadPayableInbox(request: LocalEvent, store: BillingStore): void {
        const stateChanges = request.Get<Partial<PayableInboxModel>>("stateChanges");
        store.payableInboxModel = { ...store.payableInboxModel, ...stateChanges };
    }
}

export { PayableInboxHandler };
